"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointTransformationIn = void 0;
class EndpointTransformationIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointTransformationIn.attributeTypeMap;
    }
}
exports.EndpointTransformationIn = EndpointTransformationIn;
EndpointTransformationIn.discriminator = undefined;
EndpointTransformationIn.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "enabled",
        "baseName": "enabled",
        "type": "boolean",
        "format": ""
    }
];
//# sourceMappingURL=EndpointTransformationIn.js.map